module.exports = __webpack_public_path__ + "img/bell.08276c01.png";